module.exports = __webpack_public_path__ + "static/for_whom_bg_2-75b96d38008b3108200505476fc6b95f.png";